import styled from 'styled-components';
import {
    Flex,
    Text,
    Paragraph,
    TextButton,
    IconArrowRightOutline,
    DetailedIconBrainGear,
    DetailedIconSearchHeart,
    spaceMixin,
    token,
} from '@zillow/constellation';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { trackGAMortgageEvent } from '../analytics';
import { isHappyOutcome } from '../calculations';
import { getFindHomeUrl, getDownPaymentAssistanceUrl } from '../url';

const HAPPY_CONTENT = {
    icon: <DetailedIconSearchHeart />,
    title: 'Find your new home',
    description: 'Take a look at listings in your area and get connected to a top-rated Premier Agent™.',
    urlText: 'See what’s in your budget',
    getUrl: getFindHomeUrl,
};

const UNHAPPY_CONTENT = {
    icon: <DetailedIconBrainGear />,
    title: 'Learn about down payment assistance',
    description: 'Down payment assistance can help you lower the amount you need to save for a down payment.',
    urlText: 'See if you’re eligible',
    getUrl: getDownPaymentAssistanceUrl,
};

const Wrapper = styled(Flex)`
    padding: ${spaceMixin('md')};
    border: 1px solid ${token('colors.borderLight')};
    box-shadow: 0 2px 4px ${token('colors.borderLight')};
    background-color: ${token('colors.backgroundBlue')};
`;

const getContent = outcome => (isHappyOutcome(outcome) ? HAPPY_CONTENT : UNHAPPY_CONTENT);

const SecondaryCta = ({ outputs }) => {
    useEffect(() => {
        if (outputs.outcome) {
            const { urlText } = getContent(outputs.outcome);
            trackGAMortgageEvent('Budget Calculator: Impression', `Calculator Secondary CTA "${urlText}"`);
        }
    }, [outputs.outcome]);

    if (!outputs.outcome) {
        return null;
    }

    const { icon, title, description, urlText, getUrl } = getContent(outputs.outcome);

    return (
        <Wrapper display="flex" flexDirection="column" alignItems="flex-start">
            {icon}
            <Text fontType="bodyHeading">{title}</Text>
            <Paragraph fontType="bodySmall" marginY="xs">
                {description}
            </Paragraph>
            <TextButton
                as="a"
                href={getUrl()}
                onClick={() =>
                    trackGAMortgageEvent('Budget Calculator: Click', `Calculator Secondary CTA "${urlText}"`)
                }
                icon={<IconArrowRightOutline />}
                iconPosition="end">
                {urlText}
            </TextButton>
        </Wrapper>
    );
};

SecondaryCta.propTypes = {
    outputs: PropTypes.object,
};

export default SecondaryCta;
